import React, { useEffect, useState, useCallback, lazy } from 'react';
import { useModalStore } from '../../store/modalStore';
const GameModalController = lazy(() => import('../games/GameModalController'));
const WelcomeController = lazy(() => import('./WelcomeController'));

const MODAL_EVENT_NAME = 'trigger-lang-modal'; 

const Modal = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [localModalType, setLocalModalType] = useState(null);
    const closeModalAction = useModalStore(state => state.closeModal);

    const closeModal = useCallback(() => {
        closeModalAction(); 
        setIsVisible(false);
        setLocalModalType(null);
    }, [closeModalAction]);

    const openWelcome = useCallback(() => {
        setIsVisible(true);
        setLocalModalType('welcome-flow');
    }, []);

    useEffect(() => {
        const handleNativeOpen = () => {
            openWelcome();
        };

        window.addEventListener(MODAL_EVENT_NAME, handleNativeOpen);

        const setupStatus = localStorage.getItem('app-setup-completed');
        const langStatus = localStorage.getItem('app-lang-selected');
        const isPending = setupStatus === 'PENDING' || langStatus === 'PENDING';

        if (isPending) {
            openWelcome();
        }

        return () => window.removeEventListener(MODAL_EVENT_NAME, handleNativeOpen);
    }, [openWelcome]);

    useEffect(() => {
        if (isVisible) {
            document.body.classList.add('overflow-hidden');
        } else {
            document.body.classList.remove('overflow-hidden');
        }
        return () => document.body.classList.remove('overflow-hidden');
    }, [isVisible]);

    let content;
    switch (localModalType) {
        case 'games':
            content = <GameModalController closeModal={closeModal} />;
            break;
        case 'welcome-flow': 
            content = <WelcomeController closeModal={closeModal} />;
            break;
        case 'ads':
            content = <div className="p-4 text-center">Ad content!</div>;
            break;
        default:
            content = null; 
    }

    const visibilityClasses = isVisible 
        ? 'opacity-100 pointer-events-auto bg-opacity-80' 
        : 'opacity-0 pointer-events-none bg-opacity-0';

    return (
        <div className={`fixed inset-0 z-[100] flex items-center justify-center bg-black transition-all duration-300 ${visibilityClasses} p-4`}>
            <div className="relative max-w-2xl w-full h-full md:h-auto overflow-hidden">
                <div className="w-full h-full">
                    {content}
                </div>
            </div>
        </div>
    );
};

export default Modal;